import {
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@material-ui/core';
import React from 'react';
import { formatMoney } from '../../../../utils';

const PayoutReportsTable = ({ reports, loading, groupActivities }) => {
    return (
        reports?.payouts && (
            <Grid container item>
                <TableContainer>
                    <Table className="mt-2" style={{ backgroundColor: 'white' }} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Fee name</TableCell>
                                <TableCell align="left">Account to</TableCell>
                                <TableCell align="left">Agent name</TableCell>
                                {groupActivities && <TableCell align="left">Activity</TableCell>}
                                <TableCell align="right">Sum net</TableCell>
                                <TableCell align="right">Sum tax</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading === false && reports?.payouts.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        No payouts in this range.
                                    </TableCell>
                                </TableRow>
                            )}
                            {reports?.payouts.map((payout, index) => (
                                <TableRow
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={index}
                                >
                                    <TableCell align="left">{payout.feeName}</TableCell>
                                    <TableCell align="left">{payout.accountTo}</TableCell>
                                    <TableCell align="left">
                                        {payout.user_commission
                                            ? `${payout.user_commission?.firstname} ${payout.user_commission?.lastname}`
                                            : '-'}
                                    </TableCell>
                                    {groupActivities && (
                                        <TableCell align="left">
                                            {payout?.activity_name || '-'}
                                        </TableCell>
                                    )}
                                    <TableCell align="right">
                                        {formatMoney(payout.sumNet)}
                                    </TableCell>
                                    <TableCell align="right">
                                        {formatMoney(payout.sumTax)}
                                    </TableCell>
                                </TableRow>
                            ))}
                            <TableRow>
                                <TableCell colSpan={groupActivities ? 3 : 2}></TableCell>
                                <TableCell>
                                    <b>Sum:</b>
                                </TableCell>
                                <TableCell align="right">
                                    <b>
                                        {typeof reports?.grandTotal.sumNet === 'number' &&
                                            formatMoney(reports?.grandTotal.sumNet)}
                                    </b>
                                </TableCell>
                                <TableCell align="right">
                                    <b>
                                        {typeof reports?.grandTotal.sumTax === 'number' &&
                                            formatMoney(reports?.grandTotal.sumTax)}
                                    </b>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        )
    );
};

export default PayoutReportsTable;
